import store from '@/store';

const refDataActions = [
  'coordinatingCommittees/fetchCoordinatingCommittees',
  'countries/fetchCountries',
  'addressTypes/fetchAddressTypes',
  'contactTypes/fetchContactTypes',
  'genders/fetchGenders',
  'careerStages/fetchCareerStages',
  'industryAcademiaGovernment/fetchIndustryAcademiaGovernment',
  'positions/fetchPositions',
  'positions/fetchPositionsForLiaison',
  'trienniums/fetchTrienniums',
  'conferenceTypes/fetchConferenceTypes',
  'venueTypes/fetchVenueTypes',
  'nationalMemberOrganizations/fetchNMOs',
];

function initRefData() {
  return Promise.allSettled(
    refDataActions.map((action) => store.dispatch(action)),
  );
}

export default initRefData;
